import React from 'react';
export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      fillRule="evenodd"
      d="M8.5,19 C9.32842712,19 10,19.6715729 10,20.5 C10,21.3284271 9.32842712,22 8.5,22 C7.67157288,22 7,21.3284271 7,20.5 C7,19.6715729 7.67157288,19 8.5,19 Z M17.5,19 C18.3284271,19 19,19.6715729 19,20.5 C19,21.3284271 18.3284271,22 17.5,22 C16.6715729,22 16,21.3284271 16,20.5 C16,19.6715729 16.6715729,19 17.5,19 Z M3,2 L5,2 C5.45560407,2 5.848307,2.30684025 5.96505661,2.73773928 L5.9883717,2.84794282 L6.47330357,6 L21,6 C21.5997637,6 22.0549227,6.52067883 21.9951229,7.10034708 L21.9761871,7.21693046 L20.324218,14.6507914 C20.0324549,15.9637252 18.9058923,16.91433 17.5779312,16.9945094 L17.3956568,17 L8.71583791,17 C7.2943532,17 6.07697015,16.0043648 5.78265284,14.6299072 L5.75072282,14.4561716 L4.14208104,4 L3,4 C2.44771525,4 2,3.55228475 2,3 C2,2.48716416 2.38604019,2.06449284 2.88337887,2.00672773 L3,2 L5,2 L3,2 Z M19.7533839,8 L6.78099588,8 L7.72746622,14.1520572 C7.79674409,14.6023634 8.15972961,14.9438425 8.60337063,14.9937133 L8.71583791,15 L17.3956568,15 C17.8252972,15 18.2020966,14.7264627 18.3402285,14.3284527 L18.3718438,14.2169305 L19.7533839,8 Z"
    />
  </svg>
);
